import HeaderIcon from './HeaderIcon.vue'

export default HeaderIcon
